module.exports = __webpack_public_path__ + "images/Log_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Log_hover.png
// module id = 380
// module chunks = 0 1